import { useSelector } from 'react-redux';

import styles from './styles.module.scss';

import { MetricChartLeafArea, MetricChartNdvi } from './index.jsx';
import { useViewport } from '../../hooks';
import { BreakpointMobile, BreakpointMobileUp } from '../../constants/ui';
import { getMetricsLabels } from '../../utils/metrics';

const MetricsVegetationCharts = ({ t, data }) => {
  const { widthViewport } = useViewport();
  const { activeReportChartVegetation } = useSelector((state) => state.sensors);
  const MetricsLabels = getMetricsLabels(t);

  if (!data) return;

  return (
    <div className={styles.metricsChartsContainer}>
      <div
        className={`${styles.metricsCharts} ${styles.metricsChartsVegetation}`}
        style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}
      >
        {/*Plant NDVI*/}
        {data.ndvi.data &&
          data.ndvi.data.length > 0 &&
          (widthViewport > BreakpointMobile || activeReportChartVegetation === 'ndvi') && (
            <MetricChartNdvi
              title={MetricsLabels.plantNdvi}
              data={data.ndvi}
              sensor={data.sensor}
              widthViewport={widthViewport}
            />
          )}
        {/*Leaf NDVI*/}
        {data.leafNdvi.data &&
          data.leafNdvi.data.length > 0 &&
          (widthViewport > BreakpointMobile || activeReportChartVegetation === 'leafNdvi') && (
            <MetricChartNdvi
              title={MetricsLabels.leafNdvi}
              data={data.leafNdvi}
              sensor={data.sensor}
              widthViewport={widthViewport}
            />
          )}
        {/*Leaf Area*/}
        {data.leafArea.data &&
          data.leafArea.data.length > 0 &&
          (widthViewport > BreakpointMobile || activeReportChartVegetation === 'leafArea') && (
            <MetricChartLeafArea
              title={MetricsLabels.leafArea}
              data={data.leafArea}
              sensor={data.sensor}
              widthViewport={widthViewport}
            />
          )}
        {/*Soil NDVI*/}
        {data.soilNdvi.data &&
        data.soilNdvi.data.length > 0 &&
        (widthViewport > BreakpointMobile || activeReportChartVegetation === 'soilNdvi') ? (
          <MetricChartNdvi
            title={MetricsLabels.soilNdvi}
            data={data.soilNdvi}
            sensor={data.sensor}
            widthViewport={widthViewport}
          />
        ) : (
          widthViewport < BreakpointMobileUp &&
          activeReportChartVegetation === 'soilNdvi' && <div className={styles.metricsChartsEmpty}>No data</div>
        )}
      </div>
    </div>
  );
};

export default MetricsVegetationCharts;
